import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PackageService } from '@services/packages/package.service';

@Component({
    selector: 'package-selector',
    templateUrl: './package-selector.component.html',
    styleUrls: ['./package-selector.component.scss'],
    providers: [PackageService],
    standalone: false
})
export class PackageSelectorComponent {

  params: any = {};
  columns = [{ prop: 'title', title: 'Title' }];
  importIds = [];

  constructor(public pakService: PackageService, public dialogRef: MatDialogRef<PackageSelectorComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  public onSelect(event) {
    this.dialogRef.close(event.row);
  }
}
